import Vue from 'vue'
import Vuetify from 'vuetify'
import './plugins/vuetify'
import './plugins/vuetify'
import App from './App.vue'
import MultiFiltersPlugin from './plugins/MultiFilters'
import 'vuetify/dist/vuetify.min.css'
import router from './router'
import axios from 'axios'
import Notifications from 'vue-notification'

import VDateRange from 'vuetify-daterange-picker'
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css'

Vue.config.productionTip = false
Vue.use(MultiFiltersPlugin)
Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    info: '#e6a267',
    important: '#e6a267',
    accent: '#e6a267',
    primary: '#ea6d00'
  }
})
Vue.use(Notifications)
Vue.use(VDateRange)
Vue.http = Vue.prototype.$http = axios

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
